import { memo, useCallback, useEffect } from 'react';

import { AppEvents } from '@/utils';

import { updateSessionShopify } from '@/modules/api';
import { useEvent } from '@/modules/common';

const CHECKOUT_BUTTON_SELECTOR = '.cart-footer__checkout-button';

export const SessionSyncHandler = memo(() => {
  const sendSessionInfo = useCallback(async () => {
    await updateSessionShopify();
  }, []);

  useEvent({ name: AppEvents.UPDATE_SESSION, handler: sendSessionInfo });

  useEffect(() => {
    sendSessionInfo();

    // TODO: Refactor this to use ApiApp
    const handleClick = async (event: MouseEvent) => {
      const $target = event.target as HTMLElement;
      const $button = $target.closest<HTMLAnchorElement>(CHECKOUT_BUTTON_SELECTOR);

      if ($button) {
        await sendSessionInfo();

        if ($button.href) {
          window.location.href = $button.href;
        }
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [sendSessionInfo]);

  return null;
});

SessionSyncHandler.displayName = 'SessionSyncHandler';
